import { FormEvent, useState } from 'react';

type FormAddress = {
  streetAddress: string;
  apt: string;
  city: string;
  state: string;
  postalCode: string;
};

export const useAddressFormValues = () => {
  const [inputAddress, setInputAddress] = useState<FormAddress>({
    streetAddress: '',
    apt: '',
    city: '',
    state: '',
    postalCode: '',
  });

  const parsedAddress = {
    addressLines: inputAddress.apt
      ? [inputAddress.streetAddress, inputAddress.apt]
      : [inputAddress.streetAddress],
    municipality: inputAddress.city,
    region: inputAddress.state,
    postalCode: inputAddress.postalCode,
    countryCode: 'US',
  };

  const handleAddressChange = (
    event: FormEvent<HTMLInputElement>,
    field: string
  ) => {
    const value = event.currentTarget.value;
    setInputAddress((prev) => ({ ...prev, [field]: value }));
  };

  const resetAddress = () => {
    setInputAddress({
      streetAddress: '',
      apt: '',
      city: '',
      state: '',
      postalCode: '',
    });
  };

  return { inputAddress: parsedAddress, handleAddressChange, resetAddress };
};
